import { z } from 'zod';
import { CartModifierSchema } from './CartModifier';

/**
 * The rule fields a cart line snapshots about its modifier group.
 *
 * All of the duplicate/unique dimensions are OPTIONAL: cart documents written
 * before they existed simply omit them, and `CartModifierGroup.selectionRules`
 * resolves an absent field exactly as it always did. Requiring them here would
 * fail validation on every cart already in Firestore.
 */
const selectionRuleFields = {
    selectionRequirement: z.enum(['Optional', 'Required']),
    minSelection: z.number().int().min(0),
    maxSelection: z.number().int().positive().optional(),
    allowMultipleSelection: z.boolean().optional(),
    allowDuplicateSelection: z.boolean().optional(),
    maxDuplicatesPerModifier: z.number().int().positive().optional(),
    minUniqueSelection: z.number().int().positive().optional(),
    maxUniqueSelection: z.number().int().positive().optional()
};

export const CartModifierGroupSchema = z.object({
    modifierGroupId: z.number().int().positive(),
    name: z.string().min(1).max(255),
    modifiers: z.array(CartModifierSchema),
    ...selectionRuleFields
});

export const CartModifierGroupDataSchema = z.object({
    modifierGroupId: z.number().int().positive(),
    name: z.string().min(1).max(255),
    modifiers: z.array(CartModifierSchema).default([]),
    ...selectionRuleFields,
    selectionRequirement: z.enum(['Optional', 'Required']).default('Optional'),
    minSelection: z.number().int().min(0).default(0)
});

export type CartModifierGroupSchemaType = z.infer<typeof CartModifierGroupSchema>;
export type CartModifierGroupDataSchemaType = z.infer<typeof CartModifierGroupDataSchema>;
